import React from 'react';
import { Box, Typography } from '@mui/material';
import FuncionarioVisualizar from '../components/funcionario/FuncionarioVisualizar';

const FuncionarioVisualizarPage: React.FC = () => {
  return (
    <Box>
      <Typography 
        variant="h4" 
        component="h1" 
        gutterBottom 
        sx={{ 
          fontWeight: 'bold',
          fontFamily: 'Arial, sans-serif',
          fontSize: '2.125rem',
          lineHeight: 1.235
        }}
      >
        Visualizar Funcionário
      </Typography>
      <FuncionarioVisualizar />
    </Box>
  );
};

export default FuncionarioVisualizarPage;
